<template>
    <form action="" v-if="timeLog">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Log Time</p>
            </header>
            <section class="modal-card-body">
                <div>
                    <o-field label="Project">
                        <o-select v-model="timeLog.projectId" @input="selectProject" placeholder="Select a Project" expanded>
                            <option
                                v-for="project in projects"
                                :value="project.id"
                                :key="project.id">
                                {{ project.name }}
                            </option>
                        </o-select>
                    </o-field>

                    <div class="block">
                        <label><strong>Work Type</strong></label>
                        <o-tabs v-model="activeTab">
                            <o-tab-item label="Task">
                                <o-field>
                                    <o-select v-model="timeLog.entityId" placeholder="Select a Task" expanded>
                                        <option
                                            v-for="task in tasks"
                                            :value="task.id"
                                            :key="task.id">
                                            {{ task.name }}
                                        </option>
                                    </o-select>
                                </o-field>
                            </o-tab-item>

                            <o-tab-item label="Service">
                                <o-field>
                                    <o-select v-model="timeLog.entityId" placeholder="Select a Service" expanded>
                                        <option
                                            v-for="service in services"
                                            :value="service.id"
                                            :key="service.id">
                                            {{ service.name }}
                                        </option>
                                    </o-select>
                                </o-field>
                            </o-tab-item>

                            <o-tab-item label="Misc">
                                <o-field>
                                    <o-select v-model="timeLog.workType.id" placeholder="Select a Work Type" expanded>
                                        <option
                                            v-for="otherWorkType in otherWorkTypes"
                                            :value="otherWorkType.id"
                                            :key="otherWorkType.id">
                                            {{ otherWorkType.type }}
                                        </option>
                                    </o-select>
                                </o-field>

                                <o-field label="Activity Name" v-if="isCustomWorkTypeFieldVisible">
                                    <o-input v-model="timeLog.workType.activityName"></o-input>
                                </o-field>

                            </o-tab-item>
                        </o-tabs >
                    </div>

                    <o-field label="Select working hours">
                        <vue-slider
                            :height="8"
                            :dotSize="20"
                            :show="true"
                            :speed="0.3"
                            tooltip="always"
                            :piecewise="true"
                            :data="timeRange"
                            :piecewiseStyle='{"backgroundColor": "#ccc", "visibility": "visible", "width": "12px", "height": "12px"}'
                            :processStyle='{ "backgroundColor": "#aeb916" }'
                            :piecewiseActiveStyle='{"backgroundColor": "black"}'
                            :labelActiveStyle='{"color": "black"}'
                            :tooltipStyle='{"backgroundColor": "black", "color": "white", "border-color": "black"}'
                            ref="slider"
                            v-model="timeLog.time">
                        </vue-slider>
                    </o-field>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
                <button @click.prevent="success" class="button is-primary">Save</button>
            </footer>
        </div>
    </form>
</template>

<script>
    import VueSlider from 'vue-slider-component'

    export default {
        components: { VueSlider },

        props: ['timeLogProp'],

        mounted () {
            this.timeLog = this.timeLogProp
            this.selectProject()

            if (this.timeLog.workType.name == 'task') {
                this.activeTab = 0
            } else if (this.timeLog.workType.name == 'service') {
                this.activeTab = 1
            } else {
                this.activeTab = 2
            }
        },

        data () {
            return {
                timeRange: [
                    0.0, 0.25, 0.5, 0.75,
                    1.0, 1.25, 1.5, 1.75,
                    2.0, 2.25, 2.5, 2.75,
                    3.0, 3.25, 3.5, 3.75,
                    4.0, 4.25, 4.5, 4.75,
                    5.0, 5.25, 5.5, 5.75,
                    6.0, 6.25, 6.5, 6.75,
                    7.0, 7.25, 7.5, 7.75,
                    8.0, 8.25, 8.5, 8.75,
                    9.0, 9.25, 9.5, 9.75,
                    10.0, 10.25, 10.5, 10.75,
                    11.0, 11.25, 11.5, 11.75,
                    12.0, 12.25, 12.5, 12.75,
                    13.0, 13.25, 13.5, 13.75,
                    14.0
                ],
                isCustomWorkTypeFieldVisible: false,
                activeTab: 0,
                tasks: null,
                services: null,
                timeLog: null,
                otherWorkTypes: [
                    {"id": 1, "type": "call"},
                    {"id": 2, "type": "email"},
                    {"id": 3, "type": "other"}
                ],
                projects: [
                    {"id": 1, "name": "Project Builders Group, LLC"},
                    {"id": 2, "name": "Project Builders"},
                    {"id": 3, "name": "Stamford Tent & Equipment Co"},
                    {"id": 4, "name": "Project Builders Group, LLC"},
                    {"id": 5, "name": "Terra CRG"},
                ],
                projectTasks1: [
                    {"id": 1, "name": "Please submit FA filing with the attached forms and check."},
                    {"id": 2, "name": "Please prepare Certificate of Correction paperwork."},
                    {"id": 3, "name": "Please prepare Certificate of Correction paperwork."},
                    {"id": 4, "name": "Please see attached certificate with phone number,"},
                    {"id": 5, "name": "Please prepare Certificate of Correction paperwork."},
                ],
                projectTasks2: [
                    {"id": 1, "name": "Project 2 Task 1"},
                    {"id": 2, "name": "Project 2 Task 2"},
                    {"id": 3, "name": "Project 2 Task 3"},
                    {"id": 4, "name": "Project 2 Task 4"},
                    {"id": 5, "name": "Project 2 Task 5"},
                ],
                projectTasks3: [
                    {"id": 1, "name": "Project 3 Task 1"},
                    {"id": 2, "name": "Project 3 Task 2"},
                    {"id": 3, "name": "Project 3 Task 3"},
                    {"id": 4, "name": "Project 3 Task 4"},
                    {"id": 5, "name": "Project 3 Task 5"},
                ],
                projectTasks4: [
                    {"id": 1, "name": "Project 4 Task 1"},
                    {"id": 2, "name": "Project 4 Task 2"},
                    {"id": 3, "name": "Project 4 Task 3"},
                    {"id": 4, "name": "Project 4 Task 4"},
                    {"id": 5, "name": "Project 4 Task 5"},
                ],
                projectTasks5: [
                    {"id": 1, "name": "Project 5 Task 1"},
                    {"id": 2, "name": "Project 5 Task 2"},
                    {"id": 3, "name": "Project 5 Task 3"},
                    {"id": 4, "name": "Project 5 Task 4"},
                    {"id": 5, "name": "Project 5 Task 5"},
                ],
                projectServices1: [
                    {"id": 1, "name": "Service 1"},
                    {"id": 2, "name": "Service 2"},
                    {"id": 3, "name": "Service 3"},
                    {"id": 4, "name": "Service 4"},
                    {"id": 5, "name": "Service 5"},
                ],
                projectServices2: [
                    {"id": 1, "name": "Project 2 Service 1"},
                    {"id": 2, "name": "Project 2 Service 2"},
                    {"id": 3, "name": "Project 2 Service 3"},
                    {"id": 4, "name": "Project 2 Service 4"},
                    {"id": 5, "name": "Project 2 Service 5"},
                ],
                projectServices3: [
                    {"id": 1, "name": "Project 3 Service 1"},
                    {"id": 2, "name": "Project 3 Service 2"},
                    {"id": 3, "name": "Project 3 Service 3"},
                    {"id": 4, "name": "Project 3 Service 4"},
                    {"id": 5, "name": "Project 3 Service 5"},
                ],
                projectServices4: [
                    {"id": 1, "name": "Project 4 Service 1"},
                    {"id": 2, "name": "Project 4 Service 2"},
                    {"id": 3, "name": "Project 4 Service 3"},
                    {"id": 4, "name": "Project 4 Service 4"},
                    {"id": 5, "name": "Project 4 Service 5"},
                ],
                projectServices5: [
                    {"id": 1, "name": "Project 5 Service 1"},
                    {"id": 2, "name": "Project 5 Service 2"},
                    {"id": 3, "name": "Project 5 Service 3"},
                    {"id": 4, "name": "Project 5 Service 4"},
                    {"id": 5, "name": "Project 5 Service 5"},
                ],
                // timeEntries: [
                //     {"id": 1, "duration": "25 min"},
                //     {"id": 2, "duration": "50 min"},
                //     {"id": 3, "duration": "1 hr 15 min"},
                //     {"id": 4, "duration": "1 hr 40 min"},
                //     {"id": 5, "duration": "2 hr 5 min"},
                //     {"id": 5, "duration": "2 hr 30 min"},
                //     {"id": 5, "duration": "2 hr 55 min"},
                //     {"id": 5, "duration": "3 hr 20 min"},
                //     {"id": 6, "duration": "more"},
                // ],
            }
        },
        methods: {
            success() {
                this.$swal.fire({
                    text: 'Time Log was successfull created',
                    icon: 'success'
                })
                this.$parent.$parent.$emit('update:active', false)
            },
            selectProject() {
                switch (this.timeLog.projectId) {
                    case 1:
                        this.tasks = this.projectTasks1
                        this.services = this.projectServices1
                        break
                    case 2:
                        this.tasks = this.projectTasks2
                        this.services = this.projectServices2
                        break
                    case 3:
                        this.tasks = this.projectTasks3
                        this.services = this.projectServices3
                        break
                    case 4:
                        this.tasks = this.projectTasks4
                        this.services = this.projectServices4
                        break
                    case 5:
                        this.tasks = this.projectTasks5
                        this.services = this.projectServices5
                        break
                }
            }
        },

        watch: {
            timeLog: {
                deep: true,
                handler () {
                    this.isCustomWorkTypeFieldVisible = this.timeLog.workType.id == 3 ? true : false
                }
            }
        }
    }
</script>
